import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
/* Primeiro: a base da página vem antes do CSS de cada seção, que a refina. */
import '../styles/NewHome.css';
import NewHomeHeader from '../components/home/NewHomeHeader';
import Palco from '../components/home/Palco';
import CincoAreas from '../components/home/CincoAreas';
import Saidas from '../components/home/Saidas';
import Alem from '../components/home/Alem';
import Degraus from '../components/home/Degraus';
import Perguntas from '../components/home/Perguntas';
import Contato from '../components/home/Contato';
import Fecho from '../components/home/Fecho';
import useRevelar from '../components/home/useRevelar';

/**
 * A página inicial nova. Convive com `pages/Home.js` sem tocar em nada dele:
 * as seções, os estilos e os textos (`inicio.*`) são todos próprios. Qual das
 * duas aparece em `/` é o import em `App.js`; voltar é trocar aquela linha.
 */
const NewHome = () => {
  const { hash } = useLocation();
  const raiz = useRef(null);
  useRevelar(raiz);

  /* Os links de seção do cabeçalho e do rodapé chegam de outras páginas como
     `/#pricing`; o router troca de página mas não rola até a âncora. */
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView();
  }, [hash]);

  return (
    <div className="nh-pagina">
      <NewHomeHeader />
      <main className="nh" ref={raiz}>
        <Palco />
        <CincoAreas />
        <Saidas />
        <Alem />
        <Degraus />
        <Perguntas />
        <Contato />
      </main>
      <Fecho />
    </div>
  );
};

export default NewHome;
